/**
 * Human-friendly two-letter initials from a full name.
 * Unicode-safe, honours Turkish locale so "İnci" → "İ" (not "I").
 *
 * "Gülçin Sargın"     → "GS"
 * "Ali Çoban"         → "AÇ"
 * "Mehmet"            → "M"   (single-word names get one letter)
 * "Ayşe Ergül Yıldız" → "AY"  (first + last, middle names ignored)
 * "" / null           → "?"
 */
export function nameInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].charAt(0).toLocaleUpperCase("tr");
  return (
    parts[0].charAt(0).toLocaleUpperCase("tr") +
    parts[parts.length - 1].charAt(0).toLocaleUpperCase("tr")
  );
}
